// The web build is served, not installed — users are always on the latest deploy, so it's never gated.
actual fun clientBuildInfo(): ClientBuildInfo =
    ClientBuildInfo(buildNumber = null, store = UpdateStore.NONE)
